import { defineNotificationCategory, integrationPills } from './types';

export const workIntegrationScheduleDisabledDescriptor = defineNotificationCategory(
  'work_integration_schedule_disabled',
  {
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    pills: integrationPills,
  },
);

export const workIntegrationSyncErrorDescriptor = defineNotificationCategory(
  'work_integration_sync_error',
  {
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    pills: integrationPills,
    nonDisableable: true,
  },
);

export const workIntegrationSetupCompleteDescriptor = defineNotificationCategory(
  'work_integration_setup_complete',
  {
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    pills: integrationPills,
  },
);

export const workIntegrationDisconnectedDescriptor = defineNotificationCategory(
  'work_integration_disconnected',
  {
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    pills: integrationPills,
    nonDisableable: true,
  },
);

export const workIntegrationPublishCompleteDescriptor = defineNotificationCategory(
  'work_integration_publish_complete',
  {
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    pills: (data) => [data.systemName ?? 'Integration'],
  },
);

export const workIntegrationExcludedTeamsDescriptor = defineNotificationCategory(
  'work_integration_excluded_teams',
  {
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
    pills: integrationPills,
  },
);
